module.exports = __webpack_public_path__ + "img/07冷雪健.dc0d00f4.jpg";